module.exports = __webpack_public_path__ + "880bd076785c5c7dc31cdc1728ab1250.MP3";